import React from 'react';
import Error from './Error';
import { Trans } from 'components';
import { encode } from 'utilities';
import { css } from 'react-emotion';

const codeBlock = css`
  word-break: break-all;
  width: 300px;
  color: #fff;
  margin: 0 auto;
`;

const InternalError = ({ code }) => (
  <Error
    title={<Trans>Ups! Zdarzyło się coś nieoczekiwanego i aplikacja przestała działać.</Trans>}
    subtitle={
      <div>
        <Trans>Jeśli problem się powtarza - powiadom administację portalu.</Trans>
        {code && (
          <React.Fragment>
            <br/>
            <Trans>Możesz też wysłać poniższy kod błędu, który ułatwi rozwiązanie problemu.</Trans>
          </React.Fragment>
        )}
      </div>
    }
  >
    <div className={codeBlock}>{encode(code)}</div>
  </Error>
);

export default InternalError;


// WEBPACK FOOTER //
// ./src/components/ui/InternalError.jsx